import React from 'react';
import { firmInfo } from '../mock';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[hsl(var(--primary-navy))] text-white">
      <div className="container mx-auto px-6 lg:px-12 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <h3 className="text-white font-bold text-xl mb-4">
              {firmInfo.name}
            </h3>
            <p className="body-small text-white mb-4 leading-relaxed">
              Chartered Accountants providing comprehensive financial services since {firmInfo.established}. 
              Your trusted partner for audit, taxation, and business advisory.
            </p>
            <a
              href="https://maps.app.goo.gl/NpRL47ce6GkNuV5K9"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-white hover:text-white/80 transition-colors mb-2"
            >
              <MapPin size={16} className="text-white" />
              <span className="body-small">{firmInfo.location}</span>
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="heading-6 text-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {['Home', 'About', 'Services', 'Team', 'Contact'].map((link) => (
                <li key={link}>
                  <a
                    href={`#${link.toLowerCase()}`}
                    className="body-small text-white hover:text-white/80 transition-colors"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="heading-6 text-white mb-4">Services</h4>
            <ul className="space-y-2">
              {['Audit & Assurance', 'Taxation', 'Business Advisory', 'Accounting Support'].map((service) => (
                <li key={service}>
                  <span className="body-small text-white">{service}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="body-small text-white">
              © {currentYear} {firmInfo.name}. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="body-small text-white hover:text-white/80 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="body-small text-white hover:text-white/80 transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
